/**
 * Phase 18.16-B Batch 2 — /word-agent PageBanner wrapper.
 *
 * Same pattern as OnlinePaymentPageBanner: it lives as `topSection` of
 * the /word-agent CmsPageRenderer route. The legacy "hero" block on the
 * same slug is hidden via `hideBlockTypes={["hero"]}` in App.js and
 * marked "Vervangen" in the Backoffice.
 */
import React from "react";
import { Briefcase } from "lucide-react";
import useToolPageCms from "../hooks/useToolPageCms";
import { ToolPageBanner } from "./ToolPageCms";

const FALLBACK = {
  page_banner: {
    eyebrow: "Agent worden",
    title: "Word agent voor",
    highlight: "5999Cargo",
    subtitle:
      "Bouw lokaal inkomen op met onze agent-structuur. Wij regelen logistiek, documenten en facturatie — u koppelt de klant aan ons.",
    badges: [
      { icon: "briefcase", label: "Lokale agent-structuur" },
      { icon: "support",   label: "Persoonlijke begeleiding" },
      { icon: "banknote",  label: "Maandelijkse afrekening" },
    ],
    cta_primary_label: "Vraag info aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {},
  cta_band: {},
};

export default function WordAgentPageBanner() {
  const { data } = useToolPageCms("word-agent", FALLBACK);
  const banner = data?.page_banner || FALLBACK.page_banner;
  return (
    <ToolPageBanner
      banner={banner}
      eyebrowIcon={Briefcase}
      testid="word-agent-banner"
    />
  );
}
